export default "__VITE_ASSET__0267ece7__"